export default __webpack_public_path__ + "static/media/messaging.afee821e.svg";